import { map } from 'rxjs';

import { inject } from '@angular/core';
import { type CanMatchFn } from '@angular/router';

import { AuthFacade } from '@core/auth';

export const authGuard: CanMatchFn = () => {
  const authFacade = inject(AuthFacade);

  return authFacade
    .resolveAuthStatus()
    .pipe(map((status) => (status === 'authed' ? true : authFacade.redirectForGuest())));
};
